module.exports = __webpack_public_path__ + "img/research.6dc00922.svg";